import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import ListSubheader from "@material-ui/core/ListSubheader";
import List from "@material-ui/core/List";
import MenuItem from "@material-ui/core/MenuItem";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Collapse from "@material-ui/core/Collapse";
import { ExpandMore, ExpandLess } from "@mui/icons-material";

const styles = (theme) => ({
  root: {
    width: "100%",
    maxWidth: 240,
    backgroundColor: theme.palette.background.paper,
  },
  nested: {
    paddingLeft: "50px !important",
  },
  nested2: {
    paddingLeft: "75px !important",
  },
});

const StyledMenuItem = withStyles((theme) => ({
  root: {
    "&:focus": {
      backgroundColor: `${theme.palette.primary.main} !important`,
      "& .MuiListItemIcon-root, & .MuiSvgIcon-root, & .MuiListItemText-primary": {
        color: `${theme.palette.common.white} !important`,
      },
    },
  },
  selected: {
    backgroundColor: `${theme.palette.primary.main} !important`,
    "& .MuiListItemIcon-root, & .MuiSvgIcon-root, & .MuiListItemText-primary": {
      color: `${theme.palette.common.white} !important`,
    },
  },
  dense: {
    backgroundColor: `${theme.palette.secondary.main} !important`,
  },
}))(MenuItem);

class NestedList extends React.Component {
  state = { open: {}, open2: {}, selected: this.props.defaultSelected };

  handleClick = (key) => () => {
    this.setState({ [key]: !this.state[key] });
  };

  render() {
    const { lists, classes, onSelectItem } = this.props;
    const { selected } = this.state;
    return (
      <React.Fragment>
        <List component="nav" className={classes.root}>
          {lists.map((list, indexList) => {
            const open = this.state[list.key] || false;
            return (
              <React.Fragment key={list.key}>
                {list.items != null ? (
                  <React.Fragment>
                    <StyledMenuItem button onClick={this.handleClick(list.key)}>
                      {list.icon ? (
                        <ListItemIcon>
                          <i className={list.icon}></i>
                        </ListItemIcon>
                      ) : null}
                      <ListItemText primary={<strong>{list.label}</strong>} />
                      {open ? <ExpandLess /> : <ExpandMore />}
                    </StyledMenuItem>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                      <List component="div" disablePadding>
                        {list.items.map((item, indexItem) => {
                          const open2 = this.state[item.key] || false;
                          return (
                            <React.Fragment key={item.key}>
                              {item.subitems != null ? (
                                <React.Fragment>
                                  <StyledMenuItem
                                    button
                                    onClick={this.handleClick(item.key)}
                                    className={classes.nested}
                                  >
                                    {item.icon ? (
                                      <ListItemIcon>
                                        <i className={item.icon}></i>
                                      </ListItemIcon>
                                    ) : null}
                                    <ListItemText
                                      primary={<strong>{item.label}</strong>}
                                    />
                                    {open2 ? <ExpandLess /> : <ExpandMore />}
                                  </StyledMenuItem>
                                  <Collapse
                                    in={open2}
                                    timeout="auto"
                                    unmountOnExit
                                  >
                                    <List component="div" disablePadding>
                                      {item.subitems.map(
                                        (subitem, indexItem) => {
                                          return (
                                            <React.Fragment key={subitem.key}>
                                              <StyledMenuItem
                                                button
                                                onClick={() => {
                                                  onSelectItem(subitem.key);
                                                  this.setState({
                                                    selected: subitem.key,
                                                  });
                                                }}
                                                selected={
                                                  selected === subitem.key
                                                }
                                                className={classes.nested2}
                                              >
                                                {subitem.icon ? (
                                                  <ListItemIcon>
                                                    <i
                                                      className={subitem.icon}
                                                    ></i>
                                                  </ListItemIcon>
                                                ) : null}
                                                <ListItemText
                                                  primary={subitem.label}
                                                />
                                              </StyledMenuItem>
                                            </React.Fragment>
                                          );
                                        }
                                      )}
                                    </List>
                                  </Collapse>
                                </React.Fragment>
                              ) : (
                                <React.Fragment>
                                  <StyledMenuItem
                                    button
                                    onClick={() => {
                                      onSelectItem(item.key);
                                      this.setState({ selected: item.key });
                                    }}
                                    selected={selected === item.key}
                                    className={classes.nested}
                                  >
                                    {item.icon ? (
                                      <ListItemIcon>
                                        <i className={item.icon}></i>
                                      </ListItemIcon>
                                    ) : null}
                                    <ListItemText
                                      primary={<strong>{item.label}</strong>}
                                    />
                                  </StyledMenuItem>
                                </React.Fragment>
                              )}
                            </React.Fragment>
                          );
                        })}
                      </List>
                    </Collapse>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <StyledMenuItem
                      button
                      onClick={() => {
                        onSelectItem(list.key);
                        this.setState({ selected: list.key });
                      }}
                      selected={selected === list.key}
                    >
                      {list.icon ? (
                        <ListItemIcon>
                          <i className={list.icon}></i>
                        </ListItemIcon>
                      ) : null}
                      <ListItemText primary={<strong>{list.label}</strong>} />
                    </StyledMenuItem>
                  </React.Fragment>
                )}
              </React.Fragment>
            );
          })}
        </List>
      </React.Fragment>
    );
  }
}

NestedList.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(NestedList);
